<div class="request-categorization-container">
	<header>
		<div class="title">Categorização</div>
		<msp-breadcrumb-navigation [breadcrumb]="breadcrumbNavigation"> </msp-breadcrumb-navigation>
	</header>

	<section class="body">
		<div class="folder-container">
			<div class="tab-container">
				<div class="tab">Geral</div>
			</div>

			<div class="tab-data-container">
				<section>
					<div class="section-subtitle">Tipo de serviços habilitados</div>
					<div class="checkbox-grid">
						@for (st of SERVICE_TYPES; track $index) {
							<div class="checkbox-card" [ngClass]="{ checked: serviceTypeChecked.includes(SERVICE_TYPES_ENUM[st]) }">
								<label class="checkbox-label">
									<input
										type="checkbox"
										[checked]="serviceTypeChecked.includes(SERVICE_TYPES_ENUM[st])"
										(change)="toggleServiceType(st)" />
									<span class="label-text">{{ st }}</span>
								</label>
							</div>
						}
					</div>
				</section>

				<hr class="section-divider" />

				<section class="categorization">
					<div class="section-subtitle">Categorização de serviços habilitados</div>
					<div>
						<span>Grupo: </span>
						<select (change)="getSolutionAreaFilter($any($event.target).value)">
							<option [value]="''">TODOS</option>
							@for (sa of customerSolutionAreas; track sa.id) {
								<option [value]="sa.id">{{ sa.name }}</option>
							}
						</select>

						<span>Tipo de serviço: </span>
						<select (change)="getCategorization($any($event.target).value, true)">
							<option [value]="''">SELECIONE</option>
							@for (st of customerServiceTypes; track st.id) {
								<option [value]="st.id">{{ st.name }}</option>
							}
						</select>
					</div>
					@if (idSelectedServiceType && !isLoadingCategorization) {
						<div class="categorization-map-container" [ngClass]="{ updating: isUpdatingCategorization }">
							<div class="header-line">
								<span>Competência</span>
								<span>Natureza</span>
								<span>Tópico</span>
							</div>
							<div class="scope-line" #newScopeLine>
								@if (newScopeLine.classList.contains('edit')) {
									<!-- CARD DE NOVA COMPETÊNCIA -->
									<div class="categorization-card scope">
										<div class="header">
											<input [placeholder]="'Nome da competência'" #newCategoryInput />
											<div class="actions">
												<span (click)="newScopeLine.classList.toggle('edit')">
													<fa-icon [icon]="icons.faTimes"></fa-icon>
												</span>
												<span
													(click)="
														createScope({
															id: null,
															name: newCategoryInput.value,
															label: newCategoryInput.value,
															active: 1,
															mandatoryCiBinding: $any(newCategoryMandatoryCiBinding.value),
															firstLevel: newCategoryFirstLevel.checked ? 1 : 0,
															monitoring: newCategoryMonitoring.checked ? 1 : 0,
														});
														newScopeLine.classList.toggle('edit')
													">
													<fa-icon [icon]="icons.faSave"></fa-icon>
												</span>
											</div>
										</div>
										<div class="form">
											<div class="dotted-input-container">
												<span>Vínculo com CI</span>
												<select #newCategoryMandatoryCiBinding>
													<option [value]="MANDATORY_CI_BINDING.NAO_MANDATORIO">Não Mandatório</option>
													<option [value]="MANDATORY_CI_BINDING.MANDATORIO">Mandatório</option>
													<option [value]="MANDATORY_CI_BINDING.MANDATORIO_PARA_FECHAMENTO">
														Mandatório para Fechamento
													</option>
												</select>
											</div>

											<div class="dotted-input-container">
												<span>Primeiro nível</span>
												<cpi-checkbox
													[innerText]="newCategoryFirstLevel.checked ? 'Sim' : 'Não'"
													[value]="newCategoryFirstLevel.checked"
													(oValue)="newCategoryFirstLevel.checked = $event">
												</cpi-checkbox>
												<input type="checkbox" #newCategoryFirstLevel />
											</div>

											<div class="dotted-input-container">
												<span>Monitoramento</span>
												<cpi-checkbox
													[innerText]="newCategoryMonitoring.checked ? 'Sim' : 'Não'"
													[value]="newCategoryMonitoring.checked"
													(oValue)="newCategoryMonitoring.checked = $event">
												</cpi-checkbox>
												<input type="checkbox" #newCategoryMonitoring />
											</div>
										</div>
									</div>
								} @else {
									<div class="categorization-card scope" (click)="newScopeLine.classList.toggle('edit')">
										<div class="header">
											<span>Criar nova competência</span>
											<div class="actions">
												<span>
													<fa-icon [icon]="icons.faSquarePlus"></fa-icon>
												</span>
											</div>
										</div>
									</div>
								}
							</div>
							@for (scope of categorization; track scope) {
								<div class="scope-line" #scopeLine>
									@if (scopeLine.classList.contains('edit')) {
										<!-- EDIÇÃO DE COMPETÊNCIA EXISTENTE -->
										<div class="categorization-card scope">
											<div class="header">
												<input [placeholder]="'Nome da competência'" [(ngModel)]="scope.name" />
												<div class="actions">
													<span (click)="scopeLine.classList.toggle('edit')">
														<fa-icon [icon]="icons.faTimes"></fa-icon>
													</span>
													<span (click)="scopeLine.classList.toggle('edit'); updateScope(scope)">
														<fa-icon [icon]="icons.faSave"></fa-icon>
													</span>
												</div>
											</div>
											<div class="form">
												<div class="dotted-input-container">
													<span>Ativo</span>
													<cpi-checkbox
														[innerText]="scope.active ? 'Sim' : 'Não'"
														[value]="scope.active"
														(oValue)="scope.active = $event">
													</cpi-checkbox>
												</div>

												<div class="dotted-input-container">
													<span>Vínculo com CI</span>
													<select
														(change)="scope.mandatoryCiBinding = $any($event.target).value"
														#newCategoryMandatoryCiBinding>
														<option
															[value]="MANDATORY_CI_BINDING.NAO_MANDATORIO"
															[selected]="scope.mandatoryCiBinding === MANDATORY_CI_BINDING.NAO_MANDATORIO">
															Não Mandatório
														</option>
														<option
															[value]="MANDATORY_CI_BINDING.MANDATORIO"
															[selected]="scope.mandatoryCiBinding === MANDATORY_CI_BINDING.MANDATORIO">
															Mandatório
														</option>
														<option
															[value]="MANDATORY_CI_BINDING.MANDATORIO_PARA_FECHAMENTO"
															[selected]="
																scope.mandatoryCiBinding === MANDATORY_CI_BINDING.MANDATORIO_PARA_FECHAMENTO
															">
															Mandatório para Fechamento
														</option>
													</select>
												</div>

												<div class="dotted-input-container">
													<span>Primeiro nível</span>
													<cpi-checkbox
														[innerText]="scope.firstLevel ? 'Sim' : 'Não'"
														[value]="scope.firstLevel"
														(oValue)="scope.firstLevel = $event">
													</cpi-checkbox>
												</div>

												<div class="dotted-input-container">
													<span>Monitoramento</span>
													<cpi-checkbox
														[innerText]="scope.monitoring ? 'Sim' : 'Não'"
														[value]="scope.monitoring"
														(oValue)="scope.monitoring = $event">
													</cpi-checkbox>
												</div>
											</div>
										</div>
									} @else {
										<!-- READ DE COMPETÊNCIA EXISTENTE -->
										<div class="categorization-card scope" (click)="categoryCollapse.classList.toggle('open')">
											<div class="header">
												<span>{{ scope.name }}</span>
												<div class="actions">
													<span [appConfirmButton] (onConfirmButtonClick)="deleteScope(scope)">
														<fa-icon [icon]="icons.faTrash"></fa-icon>
													</span>
													<span>
														<fa-icon [icon]="icons.faPen" (click)="scopeLine.classList.toggle('edit')">
														</fa-icon>
													</span>
													<span>
														<fa-icon
															[icon]="
																categoryCollapse.classList.contains('open')
																	? icons.faAngleDown
																	: icons.faAngleRight
															">
														</fa-icon>
													</span>
												</div>
											</div>
										</div>
									}

									<div class="category-collapse" #categoryCollapse>
										<div class="category-line" #newCategoryLine>
											@if (newCategoryLine.classList.contains('edit')) {
												<!-- CARD DE NOVA NATUREZA -->
												<div class="categorization-card category">
													<div class="header">
														<input [placeholder]="'Nome da natureza'" #newCategoryInput />
														<div class="actions">
															<span (click)="newCategoryLine.classList.toggle('edit')">
																<fa-icon [icon]="icons.faTimes"></fa-icon>
															</span>
															<span
																(click)="
																	createCategory(
																		{
																			id: null,
																			name: newCategoryInput.value,
																			label: newCategoryInput.value,
																			active: 1,
																		},
																		scope,
																		idSelectedServiceType
																	);
																	newCategoryLine.classList.toggle('edit')
																">
																<fa-icon [icon]="icons.faSave"></fa-icon>
															</span>
														</div>
													</div>
												</div>
											} @else {
												<div
													class="categorization-card category"
													(click)="newCategoryLine.classList.toggle('edit')">
													<div class="header">
														<span>Criar nova natureza</span>
														<div class="actions">
															<span>
																<fa-icon [icon]="icons.faSquarePlus"></fa-icon>
															</span>
														</div>
													</div>
												</div>
											}
										</div>
										@for (category of scope.categories; track category) {
											<div class="category-line" #categoryLine>
												@if (categoryLine.classList.contains('edit')) {
													<!-- EDIÇÃO DE NATUREZA -->
													<div class="categorization-card category">
														<div class="header">
															<input [placeholder]="'Nome da natureza'" [(ngModel)]="category.name" />
															<div class="actions">
																<span (click)="categoryLine.classList.toggle('edit')">
																	<fa-icon [icon]="icons.faTimes"></fa-icon>
																</span>
																<span
																	(click)="
																		categoryLine.classList.toggle('edit'); updateCategory(category)
																	">
																	<fa-icon [icon]="icons.faSave"></fa-icon>
																</span>
															</div>
														</div>
														<div class="form">
															<div class="dotted-input-container">
																<span>Ativo</span>
																<cpi-checkbox
																	[innerText]="category.active ? 'Sim' : 'Não'"
																	[value]="category.active"
																	(oValue)="category.active = $event">
																</cpi-checkbox>
															</div>
														</div>
													</div>
												} @else {
													<!-- READ DA NATUREZA -->
													<div
														class="categorization-card category"
														(click)="topicCollapse.classList.toggle('open')">
														<div class="header">
															<span>{{ category.name }}</span>
															<div class="actions">
																<span
																	[appConfirmButton]
																	(onConfirmButtonClick)="deleteCategory(category, scope)">
																	<fa-icon [icon]="icons.faTrash"></fa-icon>
																</span>
																<span>
																	<fa-icon
																		[icon]="icons.faPen"
																		(click)="categoryLine.classList.toggle('edit')">
																	</fa-icon>
																</span>
																<span>
																	<fa-icon
																		[icon]="
																			topicCollapse.classList.contains('open')
																				? icons.faAngleDown
																				: icons.faAngleRight
																		">
																	</fa-icon>
																</span>
															</div>
														</div>
													</div>
												}

												<div class="topic-collapse" #topicCollapse>
													<!-- <app-categorization-topic-collapse
														[category]="category"
														[(isUpdatingCategorization)]="isUpdatingCategorization">
													</app-categorization-topic-collapse> -->
													<div class="topic-line" #newTopicLine>
														<!-- CARD DE NOVO TÓPICO -->
														@if (newTopicLine.classList.contains('edit')) {
															<div class="categorization-card topic">
																<div class="header">
																	<input [placeholder]="'Nome do tópico'" #newTopicInput />
																	<div class="actions">
																		<span (click)="newTopicLine.classList.toggle('edit')">
																			<fa-icon [icon]="icons.faTimes"></fa-icon>
																		</span>
																		<span
																			(click)="
																				createTopic(
																					{
																						id: null,
																						name: newTopicInput.value,
																						label: newTopicInput.value,
																						active: 1,
																						sla: newTopicSlaInput.value
																							? +newTopicSlaInput.value
																							: null,
																					},
																					category
																				);
																				newTopicLine.classList.toggle('edit')
																			">
																			<fa-icon [icon]="icons.faSave"></fa-icon>
																		</span>
																	</div>
																</div>
																<div class="form">
																	<div class="dotted-input-container">
																		<span>SLA (minutos)</span>
																		<input type="number" #newTopicSlaInput />
																	</div>
																</div>
															</div>
														} @else {
															<div
																class="categorization-card topic"
																(click)="newTopicLine.classList.toggle('edit')">
																<div class="header">
																	<span>Criar novo tópico</span>
																	<div class="actions">
																		<fa-icon [icon]="icons.faSquarePlus"></fa-icon>
																	</div>
																</div>
															</div>
														}
													</div>
													@for (topic of category.topics; track topic) {
														<div class="topic-line" #topicLine>
															@if (topicLine.classList.contains('edit')) {
																<!-- EDIÇÃO DE TÓPICO EXISTENTE -->
																<div class="categorization-card topic">
																	<div class="header">
																		<input [placeholder]="'Nome do tópico'" [(ngModel)]="topic.name" />
																		<div class="actions">
																			<span (click)="topicLine.classList.toggle('edit')">
																				<fa-icon [icon]="icons.faTimes"></fa-icon>
																			</span>
																			<span
																				(click)="
																					topicLine.classList.toggle('edit');
																					updateTopic(topic, category)
																				">
																				<fa-icon [icon]="icons.faSave"></fa-icon>
																			</span>
																		</div>
																	</div>
																	<div class="form">
																		<div class="dotted-input-container">
																			<span>Ativo</span>
																			<cpi-checkbox
																				[innerText]="topic.active ? 'Sim' : 'Não'"
																				[value]="topic.active"
																				(oValue)="topic.active = $event">
																			</cpi-checkbox>
																		</div>
																		<div class="dotted-input-container">
																			<span>SLA (minutos)</span>
																			<input type="number" [(ngModel)]="topic.sla" />
																		</div>
																	</div>
																</div>
															} @else {
																<!-- READ DO TÓPICO EXISTENTE -->
																<div class="categorization-card topic">
																	<div class="header">
																		<span>{{ topic.name }}</span>
																		<div class="actions">
																			<span
																				[appConfirmButton]
																				(onConfirmButtonClick)="deleteTopic(topic, category)">
																				<fa-icon [icon]="icons.faTrash"></fa-icon>
																			</span>
																			<span (click)="topicLine.classList.toggle('edit')">
																				<fa-icon [icon]="icons.faPen"></fa-icon>
																			</span>
																		</div>
																	</div>
																</div>
															}
														</div>
													}
												</div>
											</div>
										}
									</div>
								</div>
							}
						</div>
					}
				</section>

				<section>
					@if (idSelectedServiceType && categorization?.length > 0 && !isLoadingCategorization) {
						<textarea
							[value]="categorizationTextMap"
							[rows]="8"
							(input)="handleIdentMap($event)"
							(keydown)="handleIdentMapSpecialKeys($event)"></textarea>
						<div class="button-container">
							<msp-button (click)="saveIdentMap()" [loading]="isUpdatingCategorization" [disabled]="isUpdatingCategorization">
								Salvar
							</msp-button>
						</div>
					}
				</section>
			</div>
		</div>
	</section>
</div>
